import React from 'react';
import CheckRadioBase from './CheckRadioBase';
import './RadioButton.less';

function RadioButton(props) {
    return <CheckRadioBase type="radio" {...props} />;
}

RadioButton.propTypes = {
    ...CheckRadioBase.propTypes
};

RadioButton.defaultProps = {
    ...CheckRadioBase.defaultProps
};

RadioButton.displayName = 'RadioButton';

export default RadioButton;
